// plan-02 S03: standing wave pass — 48 cycles, bible S13B + S15

import type { DrawPass } from '../canvas'

// plan-08: portal doubles the standing-wave amplitude during descent
let portalAmpMultiplier = 1

export function setPortalAmpMultiplier(m: number): void {
  portalAmpMultiplier = m
}

export function createStandingWave(
  getUnmuted: () => boolean,
  reduced: boolean,
): DrawPass {
  let phase = 0

  return (ctx, w, h, _t): void => {
    const bandH = 80
    const y0 = h - bandH
    const cycles = 48
    const amp = bandH * 0.25 * portalAmpMultiplier
    const baseOpacity = (getUnmuted() ? 0.10 : 0.06) * portalAmpMultiplier

    // fundamental — 48 cycles
    ctx.beginPath()
    ctx.strokeStyle = `rgba(0, 180, 0, ${reduced ? baseOpacity * 0.5 : baseOpacity})`
    ctx.lineWidth = 1
    for (let x = 0; x <= w; x += 2) {
      const y = y0 + bandH * 0.5 + Math.sin((x / w) * cycles * Math.PI * 2 + phase) * amp
      if (x === 0) ctx.moveTo(x, y)
      else ctx.lineTo(x, y)
    }
    ctx.stroke()

    // harmonic — 96 cycles, fainter
    ctx.beginPath()
    ctx.strokeStyle = `rgba(0, 180, 0, ${reduced ? 0.02 : 0.04})`
    for (let x = 0; x <= w; x += 2) {
      const y = y0 + bandH * 0.5 + Math.sin((x / w) * cycles * 2 * Math.PI * 2 + phase * 2) * amp * 0.3
      if (x === 0) ctx.moveTo(x, y)
      else ctx.lineTo(x, y)
    }
    ctx.stroke()

    if (!reduced) phase += 0.02
  }
}
